import React, { useState } from "react";
import { toast } from "react-toastify";
import AddOrderForm from "../components/AddOrderForm";
import axiosInstance from "../api/axiosInstance";
import { validateOrder } from "../utils/validateOrder";

function PublicOrderPage() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    location: "",
    categories: [],
    locationOnMap: "",
    notes: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submittedOrder, setSubmittedOrder] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value
    });
  };

  const handleCategoriesChange = (categories) => {
    setFormData((prev) => ({
      ...prev,
      categories
    }));
    setErrors((prev) => ({
      ...prev,
      categories: null
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateOrder(formData);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) return;

    setIsSubmitting(true);

    try {
      const response = await axiosInstance.post(
        `/orders/public`,
        formData
      );

      const order = response.data?.order || response.data || {};
      setSubmittedOrder(order);
      setFormData({
        name: "",
        phone: "",
        location: "",
        categories: [],
        locationOnMap: "",
        notes: "",
      });
      toast.success("تم إرسال طلبك بنجاح ✅");
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status === 400) {
          toast.error(error.response.data.message || "بيانات غير صحيحة ❌");
        } else if (status === 429) {
          toast.error( "تم إرسال طلبات كثيرة خلال وقت قصير، الرجاء المحاولة لاحقًا");
        } else if (status === 422) {
          toast.error("البيانات المدخلة غير صالحة ❌");
        }
      } else if (error.request) {
        toast.error("خطأ في الاتصال بالخادم ⚠️");
      } else {
        console.error(error);
        toast.error("فشل إرسال الطلب ❌");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  if (submittedOrder) {
    const orderNumber = submittedOrder.order_no;

    return (
      <div className="add-container">
        <div className="add-box public-order-success">
          <h2>تم إرسال الطلب</h2>
          <p>
            سنراجع بياناتك ونتواصل معك لتأكيد التفاصيل.
          </p>
          {orderNumber && (
            <p className="public-order-number">
              رقم الطلب: {orderNumber}
            </p>
          )}
          <button
            type="button"
            className="add-btn"
            onClick={() => setSubmittedOrder(null)}
          >
            إرسال طلب آخر
          </button>
        </div>
      </div>
    );
  }

  return (
    <AddOrderForm
      formData={formData}
      errors={errors}
      isSubmitting={isSubmitting}
      onChange={handleChange}
      onCategoriesChange={handleCategoriesChange}
      onSubmit={handleSubmit}
      title="طلب جديد"
      submitLabel="إرسال الطلب"
      submittingLabel="جارٍ الإرسال..."
      showPriority={false}
    />
  );
}

export default PublicOrderPage;
